var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProductDetailsBuyIcon = function SvgProductDetailsBuyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#product_details_buy_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "product_details_buy_icon_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#product_details_buy_icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.406,
    d: "M3.182 14.173v5.845l8.894 3.203 8.895-3.203v-5.92"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.406,
    d: "M8.443 6.954 3.182 8.871M20.818 8.871l-5.2-1.964"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "product_details_buy_icon_svg__c",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.406,
    mask: "url(#product_details_buy_icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.067 12.091 9.45 16.593.703 13.197l2.479-4.325z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.066 12.091 8.752-3.22 2.479 4.327-8.748 3.395zm0 0v11.13M16.123 4.902a4.123 4.123 0 1 1-8.246 0 4.123 4.123 0 0 1 8.246 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.5 5.143.894.894 2.13-2.13"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "product_details_buy_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgProductDetailsBuyIcon;